export enum ASSET_CONDITION {
  NEW = 0,
  DEMO = 1,
  USED = 2,
}
export const assetConditionOptions = Object.values(ASSET_CONDITION)
export const assetConditionMap = {
  [ASSET_CONDITION.NEW]: 'New',
  [ASSET_CONDITION.DEMO]: 'Demo',
  [ASSET_CONDITION.USED]: 'Used',
}
